import React from 'react';
import PositionCard from '../PositionCard/PositionCard.js';
import styles from './ProfessorPositions.module.css'; // Add this import

function PositionsGrid({ positions, onMatchClick, onPositionDeleted, onEdit }) {
  // Handle position deletion
  const handlePositionDeleted = (deletedPositionId) => {
    // Notify parent component to update the positions list
    if (onPositionDeleted) {
      onPositionDeleted(deletedPositionId);
    }
  };

  return (
    <div className={styles.positionsGridCard}>
      <div className={styles.cardHeader}>
        <h2 className={styles.cardTitle}>My Positions ({positions.length})</h2>
      </div>
      <div className={styles.cardContent}>
        {positions.length === 0 ? (
          <div className={styles.emptyState}>
            <div className={styles.emptyIcon}>
              <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <h3 className={styles.emptyTitle}>No positions created yet</h3>
            <p className={styles.emptyDescription}>
              Switch to the "Create Position" tab to add your first position.
            </p>
          </div>
        ) : (
          <div className={styles.positionsGrid}>
            {positions.map(position => (
              <div key={position._id} className={styles.positionItem}>
                <PositionCard
                  position={position}
                  onDelete={handlePositionDeleted} // Pass deletion handler to each card
                  onMatch={onMatchClick} // Pass match handler to each card
                  onEdit={onEdit} // Pass edit handler to each card
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default PositionsGrid;
